import { toasterMsg } from "../../../../../Components/Toaster/Toaster";
import t from "./Submit.type";
import { getSampleRequestsTodoListService, getTodolistCountService, exportExcelService, exportToPdfService, removeSubmitDataFromList } from "../../../../../services/todo-list.service";
import { imageUrl } from "../../../../../Components/helper";

export const getSubmitList = (pramams) => async (dispatch) => {
  try {
    const requestId = pramams.requestId || Date.now().toString();
    const res = await getSampleRequestsTodoListService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_SUBMIT_REQUESTS_TODOLIST,
        payload: {
          data: res.data.doc,
          totalCount: res.data.totalCount,
          searchText: pramams.searchText,
          isScrolled: pramams.isScrolled,
          requestId,
        },
      });
      return res.data.doc;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getSubmitTodolistCount = (pramams) => async (dispatch) => {
  try {
    const res = await getTodolistCountService(pramams);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_SUBMIT_TODO_LIST_COUNT,
        payload: {
          totalCount: res.data.totalCount,
          type: pramams.type,
        },
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const setSelectedIds = (idsArr) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_SUBMIT_SELECTED_IDS_ARRAY,
      payload: idsArr,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const filterSortData = (obj) => async (dispatch) => {
  try {
    await dispatch({
      type: t.SET_SUBMIT_SORT_DATA,
      payload: obj,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const exportExcel = (params) => async () => {
  try {
    const res = await exportExcelService(params);
    if (res?.data?.fileName) {
      const fileName = res.data.fileName.toString();
      const fileUrl = res.data.zipUrl?.startsWith('http') ? res.data.zipUrl : `${imageUrl}/${res.data.zipUrl}`;

      fetch(fileUrl)
        .then((response) => response.blob())
        .then((blob) => {
          const fileObjectURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = fileObjectURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileObjectURL);
        })
        .catch((error) => console.error('Download error:', error));
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const exportToPdf = (params) => async () => {
  try {
    const res = await exportToPdfService(params);
    if (res?.data?.fileName) {
      const fileName = res.data.fileName.toString();
      const fileUrl = res.data.zipUrl?.startsWith('http') ? res.data.zipUrl : `${imageUrl}/${res.data.zipUrl}`;

      fetch(fileUrl)
        .then((response) => response.blob()) // Convert response to a Blob
        .then((blob) => {
          const fileObjectURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = fileObjectURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileObjectURL); // Cleanup
        })
        .catch((error) => console.error('Download error:', error));
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const removeSubmitDataFromListAction = (pramams) => async (dispatch) => {
  try {
    const res = await removeSubmitDataFromList(pramams);
    if (res?.code === 200) {
      toasterMsg('Removed successfully', 'success');
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};
